import React from 'react';
import { t } from '../lib/i18n';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { money } from '../lib/constants';
import { BellRing, Banknote, Mail } from 'lucide-react';

export default function RenewalAlerts({ shops, onPay, onEmail }) {
  const due = (shops || []).filter(s => s.feeStatus !== 'ok').sort((a, b) => a.daysLeft - b.daysLeft);
  if (due.length === 0) return null;
  const total = due.reduce((a, s) => a + (s.yearlyFee || 0), 0);
  return (
    <Card className="mt-8 border-amber-500/30 bg-amber-500/5 text-slate-100" data-testid="renewal-alerts">
      <CardContent className="p-5">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <div data-testid="renewal-reminder-heading" className="flex items-center gap-2 font-semibold text-amber-300"><BellRing className="h-4 w-4" />{t('Subscription reminders: {{count}}', { count: due.length })}</div>
          <div className="text-xs text-slate-300">Total to collect: <span className="font-mono text-amber-300" data-testid="renewal-total">€{money(total)}</span></div>
        </div>
        <p className="text-xs text-slate-400 mt-1">Each of these shops sees the same reminder in their portal, and shops with an admin email are emailed automatically at 30 days, 7 days, on the due date and when expired (you get a copy). Record the yearly payment to renew them for another year.</p>
        <ul className="mt-3 grid sm:grid-cols-2 gap-2 text-sm">
          {due.map(s => (
            <li key={s.id} data-testid={`renewal-item-${s.id}`} className="flex items-center justify-between gap-2 rounded-md bg-slate-950/40 border border-slate-800 px-3 py-2">
              <div className="min-w-0">
                <div className="font-medium truncate">{s.name} <span className="text-slate-400 font-normal">• {s.adminUsername}</span></div>
                <div className={`text-xs ${s.daysLeft < 0 || s.feeStatus === 'suspended' ? 'text-rose-300' : 'text-amber-300'}`}>
                  {s.feeStatus === 'suspended' ? 'Suspended' : s.daysLeft < 0 ? `${-s.daysLeft}d overdue` : s.daysLeft === 0 ? 'Due today' : `Due in ${s.daysLeft}d`} • {s.activeUntil} • <span className="font-mono">€{money(s.yearlyFee)}</span>
                </div>
              </div>
              <div className="flex gap-1.5 shrink-0">
                {onEmail && <Button data-testid={`renewal-email-${s.id}`} size="sm" variant="outline" disabled={!s.adminEmail} title={s.adminEmail ? `Email ${s.adminEmail} now` : 'No admin email on file'} onClick={() => onEmail(s)} className="border-slate-700 bg-transparent text-slate-200 hover:bg-slate-800 hover:text-white"><Mail className="h-4 w-4" /></Button>}
                {onPay && <Button data-testid={`renewal-pay-${s.id}`} size="sm" variant="outline" onClick={() => onPay(s)} className="border-slate-700 bg-transparent text-slate-200 hover:bg-slate-800 hover:text-white"><Banknote className="h-4 w-4 mr-1.5" /> Record payment</Button>}
              </div>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
}
